import { gql } from "@apollo/client";

const BOOKING_FIELDS = `
  id
  eventId
  userId
  customerName
  customerEmail
  customerPhone
  horseIds
  startTime
  endTime
  status
  notes
  depositAmount
  depositPaidAt
  stripeSessionId
  stripePaymentIntentId
  checkedInAt
  completedAt
  scanAmount
  balanceDue
  balancePaidAt
  balancePaymentIntentId
  invoiceId
  invoiceHostedUrl
  createdAt
  updatedAt
`;

export const LIST_BOOKINGS = gql`
  query listBookings($eventId: ID!, $from: AWSDateTime, $to: AWSDateTime) {
    listBookings(eventId: $eventId, from: $from, to: $to) {
      items { ${BOOKING_FIELDS} }
    }
  }
`;

export const LIST_BOOKINGS_BY_DATE = gql`
  query listBookingsByDate($date: AWSDate!) {
    listBookingsByDate(date: $date) {
      items { ${BOOKING_FIELDS} }
    }
  }
`;

export const GET_AVAILABILITY = gql`
  query getAvailability($eventId: ID!, $date: AWSDate!) {
    getAvailability(eventId: $eventId, date: $date) {
      startTime
      endTime
      remaining
    }
  }
`;

const CUSTOMER_SEARCH_FIELDS = `
  id
  email
  firstName
  lastName
  name
  phone
`;

export const SEARCH_CUSTOMERS_FOR_ADMIN = gql`
  query searchCustomersForAdmin($query: String!, $limit: Int) {
    searchCustomersForAdmin(query: $query, limit: $limit) {
      ${CUSTOMER_SEARCH_FIELDS}
    }
  }
`;

export const GET_HORSES_BY_IDS = gql`
  query getHorsesByIds($ids: [ID!]!) {
    getHorsesByIds(ids: $ids) {
      id
      name
      registeredName
      photo
      color
      height
      discipline
    }
  }
`;

export const LIST_HORSES_FOR_USER = gql`
  query listHorsesForUser($userId: ID!, $email: AWSEmail, $limit: Int) {
    listHorsesForUser(userId: $userId, email: $email, limit: $limit) {
      items {
        id
        name
        registeredName
        userId
      }
      nextToken
      count
    }
  }
`;
